module.exports = {
      id: "icons:question-circle-usage",
      viewBox: "0 0 24 24",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:question-circle-usage",
      toString: function () {
        return this.url;
      }
    }